type PaginationBuilder = {
  page: number;
  pageSize: number;
};

const assertNotLowerThanOne = (subject: string, page: number) => {
  if (page < 1) {
    throw new Error(`${subject} '${page}' is lower than 1`);
  }
};

export class Pagination {
  readonly #page: number;
  readonly #pageSize: number;

  constructor(builder: PaginationBuilder) {
    assertNotLowerThanOne('Page', builder.page);
    assertNotLowerThanOne('Page size', builder.pageSize);
    this.#page = builder.page;
    this.#pageSize = builder.pageSize;
  }

  static of(builder: PaginationBuilder): Pagination {
    return new Pagination(builder);
  }

  get page(): number {
    return this.#page;
  }

  get pageSize(): number {
    return this.#pageSize;
  }
}
